
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';

export const useScrollToTop = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Skip scroll to top for calendar (/) and clients pages to allow scroll restoration
    if (location.pathname === '/' || location.pathname === '/clients' || location.pathname === '/calendar') {
      return;
    }

    const urlTimeSlot = searchParams.get('timeSlot');
    if (urlTimeSlot) {
      return;
    }


    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [location.pathname, searchParams]);
};
